<template>
    <div :id="videoId"></div>
</template>

<script>
    import idMixin from '@/mixins/aha-id';

    export default {
        mixins: [ idMixin ],
        props: {
            videoName: {
                required: true,
                type: String
            },
            loginId: {
                require: true,
                type: String
            },
            channelId: {
                required: true,
                type: String
            },
            apiBase: {
                required: true,
                type: String
            },
            scriptSrc: {
                required: true,
                type: String
            }
        },
        data() {
            return {
                videoId: null
            }
        },
        methods: {
            loadScript() {
                if(document) {
                    const script = document.createElement('script');
                    script.setAttribute('src', this.scriptSrc);
                    document.head.appendChild(script);
                }
            }
        },
        mounted() {
            this.videoId = this.videoName + this.safeId('__TP_video_');
            window.__TVPage__ = window.__TVPage__ || {};
            window.__TVPage__.config = __TVPage__.config || {};
            window.__TVPage__.config[this.videoName] = {
                loginid: this.loginId,
                channel: { 
                    "id": this.channelId
                },
                targetEl: this.videoId,
                api_base_url: this.apiBase
            };
            this.$nextTick(this.loadScript);
        }
    }
</script>


// WEBPACK FOOTER //
// src/app/components/aha-tv-page-modal.vue